import { updateCallStatus } from 'features/call';
import * as IISightAPI from 'common/helpers/api';
import { xmpp_username_override, xmpp_password_override, ACCESS_TOKEN } from 'config';
import { toggleLobbyMode, } from '../../react/features/lobby/actions.any';
import { updateTranslationLanguage, setRequestingSubtitles } from 'jitsi/subtitles/actions.any';
// @ts-ignore
import { setMediaMuteState } from 'jitsi/toolbox/actions.web';
import { loadHidePreMeetingPageOptions } from 'initializers/loadHidePreMeetingPageOptions';
import { loadVirtualBackgroundOptions } from 'initializers/loadVirtualBackgroundOptions';
import { sendMessage } from 'jitsi/chat/actions.any';
async function _hideMeeting() {
    // if (localStorage.getItem('isVconnectCaller') === 'true' || window.APP.room.vconnectCaller == true)
    //     return;
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    while (!APP.conference._room.room.meetingId) {
        // Wait for 1000ms before checking again
        await wait(1000);
    }
    const access_token = localStorage.getItem('11S_TOKEN') || ACCESS_TOKEN;
    await IISightAPI.hideMeeting({
        id: APP.conference._room.room.meetingId,
        access_token: access_token,
    });
}
export async function iisightInitializeVconnectTracks() {
    if (window.APP.room.vconnect) {
        setTimeout(async () => {
            this.muteAudio(localStorage.getItem('isAudioMuted') === 'false' ? false : true);
            this.muteVideo(localStorage.getItem('isVideoMuted') === 'false' ? false : true);
        }, 3000);
    }
}
export async function iisightInitializeUser() {
    if (window.APP.room.vconnect) {
        setTimeout(async () => {
            this.muteAudio(localStorage.getItem('isAudioMuted') === 'false' ? false : true);
            this.muteVideo(localStorage.getItem('isVideoMuted') === 'false' ? false : true);
        }, 3000);
    }
    else if (APP?.room?.organisation_id === 699 || APP?.room?.organisation_id === 781) {
        setTimeout(async () => {
            this.muteAudio(false);
            this.muteVideo(false);
        }, 3000);
    }
    else if (APP.room.audio_video_permission === 'enabled') {
        APP.store.dispatch(setMediaMuteState(false));
    }
    let userRole = null;
    if (APP?.user?.memberships)
        APP?.user?.memberships.map((org) => {
            if (org.id == APP?.room?.organisation_id)
                userRole = org.role;
        });
    if (localStorage.getItem('isMeetingAuditor') == 'true' &&
        APP?.user?.email &&
        (userRole == 'manager' || userRole == 'owner' || userRole == 'auditor')) {
        window.APP.isMeetingAuditor = true;
        window.localStorage.setItem('xmpp_username_override', xmpp_username_override);
        window.localStorage.setItem('xmpp_password_override', xmpp_password_override);
    }
    else if (!config.iAmRecorder) {
        window.localStorage.removeItem('xmpp_username_override');
        window.localStorage.removeItem('xmpp_password_override');
    }
    const user = APP.user;
    if (user) {
        this.changeLocalEmail(user.email);
        this.changeLocalDisplayName(`${user.first_name} ${user.last_name}`);
    }
    else if (window.APP.room.vconnect && localStorage.getItem('displayName')) {
        this.changeLocalDisplayName(localStorage.getItem('displayName'));
    }
    else {
        this.changeLocalEmail('');
    }
    const { dispatch, getState } = window.APP.store;
    const state = getState();
    loadHidePreMeetingPageOptions(state, dispatch);
    await loadVirtualBackgroundOptions(state, dispatch);
}
export function onConferenceJoined() {
    if (window.APP.room.vconnect) {
        setTimeout(async () => {
            window.parent.postMessage({
                mType: 'iisight',
                message: 'vmeetJoined',
                meetingId: APP?.conference?._room?.room?.meetingId,
                userId: window.APP.room.user_id,
                participantId: APP?.conference?.getMyUserId(),
            }, '*');
            await _hideMeeting();
        }, 15000);
    }
    window.onmessage = function (e) {
        switch (e.data) {
            case 'iisight_start_recording':
                APP.store.dispatch({ type: 'START_RECORDING' });
                break;
            case 'iisight_stop_recording':
                APP.store.dispatch({ type: 'STOP_RECORDING' });
                break;
            case 'iisight_toggle_transcription':
                let enabled = APP.store.getState()['features/subtitles']._requestingSubtitles;
                if (enabled) {
                    APP.store.dispatch(setRequestingSubtitles(false));
                    APP.store.dispatch(updateTranslationLanguage('translation-languages:en'));
                }
                else {
                    APP.store.dispatch(setRequestingSubtitles(true));
                    APP.store.dispatch(updateTranslationLanguage('translation-languages:en'));
                }
                break;
            default:
                // Handle other cases if needed
                break;
        }
    };
    setTimeout(async () => {
        this.hangup();
    }, 24 * 60 * 60 * 1000);
    const { noise_supression, enable_knocking, welcome_message } = APP.room.conference_options;
    const { room, isModerator } = window.APP || {};
    const isVconnectCallee = room?.vconnect && !room.vconnectCaller && isModerator;
    const { dispatch } = APP.store;
    // setTimeout(() => {
    //   dispatch(setNoiseSuppressionEnabled(!!noise_supression));
    // }, 30000);
    setTimeout(() => {
        dispatch(toggleLobbyMode(!!enable_knocking));
    }, 1500);
    if (isVconnectCallee)
        setTimeout(() => {
            dispatch(sendMessage(welcome_message || ""));
        }, 1500);
}
export function iisightHangup() {
    window.onbeforeunload = function () {
        // Remove onbeforeunload listener so as no display default dialog
    };
    if (window.APP.room.vconnect || JSON.parse(localStorage.getItem('isVconnect'))) {
        const participants = this.listMembers();
        const message = {
            mType: 'iisight',
            message: 'vmeetEnded',
            meetingId: APP?.conference?._room?.room?.meetingId,
            userId: window.APP.room.user_id,
            participantId: APP?.conference?.getMyUserId(),
            chatMessages: this._chatMessages || [],
        };
        if (participants.length < 2) {
            window.parent.postMessage(message, '*');
        }
    }
    localStorage.removeItem('11S_TOKEN');
    localStorage.removeItem('xmpp_username_override');
    localStorage.removeItem('xmpp_password_override');
}
export function iisightEventListenersSetup() {
    APP.connection.xmpp.connection._stropheConn.addHandler((msg) => {
        try {
            const jsonMessage = $(msg).find('>json-message').text();
            const parsedJson = JSON.parse(jsonMessage);
            if (parsedJson.call_status) {
                APP.store.dispatch(updateCallStatus(parsedJson.call_status));
            }
        }
        catch (e) {
        }
        finally {
            return true;
        }
    }, null, 'message', null, null);
}
export async function _startMeetingAudit() {
    if (window.APP.isMeetingAuditor) {
        const res = await IISightAPI.startMeetingAudit({
            id: APP.conference._room.room.meetingId,
            user_id: window.APP?.user?.id,
        });
        const { data: body } = res;
        window.APP.meeting_audit_id = body.audit_id;
    }
}
export async function _endMeetingAudit() {
    if (window.APP.isMeetingAuditor) {
        const res = await IISightAPI.endMeetingAudit({
            id: APP.conference._room.room.meetingId,
            auditId: window.APP.meeting_audit_id,
        });
        const { data: body } = res;
        window.APP.meeting_audit_id = body.audit_id;
        return body;
    }
    else
        return;
}
/**
 * Check Participants and Moderator Status before ending Vconnect Call
 *
 * @returns {Promise}
 */
export function checkVconnectParticipantsAndDisconnect() {
    const message = {
        mType: 'iisight',
        message: 'vmeetEnded',
        meetingId: APP?.conference?._room?.room?.meetingId,
        userId: window.APP.room.user_id,
        participantId: APP?.conference?.getMyUserId(),
        chatMessages: APP.store.getState()['features/chat'].messages,
    };
    window.parent.postMessage(message, '*');
}
